module.exports = __webpack_public_path__ + "static/logo-9f89e1c8799181778082d44b2a9f6858.svg";